import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-MediumNew.woff2';
import woff from '../src/PPMori-MediumNew.woff';

export const ppMoriMedium: FontFaceSpec = {
  weight: 500,
  style: 'normal',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
